import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { AreaApi } from "../../../../Shared/Constants/api";
import { getAreaCreationObject } from "../Data/AreaWrappers";

export const createAreaApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${AreaApi}`,
      getAreaCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
